
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import MomentsCard from '../components/league/momentsCard.vue'
import {wxShareConfig} from '../js/common/utils'
import configInfo from "../configInfo.js"
export default {
props: {



},
components: {
Tab,
TabItem,
Scroller,
Divider,
XSwitch,
Group,
Spinner,
ButtonTab,
ButtonTabItem,
Flexbox,
FlexboxItem,
MomentsCard
},
mounted(){

this.momentsInfo = [];
if(this.eventHub){
this.eventHub.$on('loadMoreMoments', () => {
this.loadMore();
})
this.eventHub.$on('refreshTabMoments', () => {
this.refreshTab();
})
}
this.initTab();
},
beforeRouteLeave (to, from, next) {
if(this.currentPage){

}
next();
},
methods: {
initWxShareConfig:function(){
this.currentPage = window.location.href;
var fullPath = window.location.href;


var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
if (this.leagueBasicInfo.league_logo) {
shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
}
console.log(fullPath)


wxShareConfig({
title: this.leagueBasicInfo.title+'-精彩瞬间',
desc: "来自未来足球赛事系统",
link: fullPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {
console.log("share success")
}, () => {
console.log("share error")
});
},
initMoments(data){
if (data && data.length > 0) {
this.momentsStart = data.length;
this.momentsInfo = data;
console.log(this.momentsInfo, '---------------')
} else {
this.momentsStart = 0;
this.momentsInfo = [];
this.nodataTxt = "暂无数据";
}
},
loadMoreMomentsInfo(data) {
if (data && data.length > 0) {
this.momentsStart += data.length;
for (var i = 0; i < data.length; i++) {
this.momentsInfo.push(data[i])
}
} else {
this.nodataTxt = "暂无数据";
}
return;
},
loadData(id, start, length, type, successCall, afterCall){

this.hagkHttp(this.hagkApi.getLeagueMatchesAssets(id, start, length), {})
.then((res) => {
if (res.status == true) {
successCall(res.result);
}
afterCall();
}, (error) => {
afterCall();
});
},
initTab(){
this.eventHub.$emit("setTabIndex", "leagueMoments");
this.initWxShareConfig();
var leagueId = parseInt(this.leagueId)
if(this.momentsInfo.length == 0 ) {
this.$vux.loading.show({
text: '加载中...'
})
this.loadData(leagueId, 0, 5, "reserved", this.initMoments, () => {
this.$vux.loading.hide()
})
}
},
refreshTab(){
var leagueId = parseInt(this.leagueId)
this.loadData(leagueId, 0, 5, "reserved", this.initMoments, () => {
this.eventHub.$emit("enablerefreshTab")
})
},
loadMore(){
var leagueId = parseInt(this.leagueId)
this.loadData(leagueId, this.momentsStart, 5, "reserved", this.loadMoreMomentsInfo, () => {
this.eventHub.$emit("enableloadMore")
})
}
},
data () {
return {
currentPage:null,
nodataTxt:"暂无数据",
momentsStart: 0,
momentsInfo: [
],
leagueId:this.$route.query.leagueId,
eventHub:this.$store.getters.getEventHub,
leagueBasicInfo: this.$store.getters.getLeagueBasicInfo,
currentOrgCode: configInfo.orgCode
}
}
}



// WEBPACK FOOTER //
// ./src/views/leagueMoments.vue